var validCyrillicInEmail = function validCyrillicInEmail(_a) {
  var _b = _a === void 0 ? {} : _a,
    _c = _b.message,
    message = _c === void 0 ? 'Email содержит кириллические и латинские символы' : _c;
  return function (email) {
    return email && email.split('@').some(function (part) {
      return /([a-z]+.*[а-яё]+)|([а-яё]+.*[a-z]+)/gi.test(part);
    }) ? message : undefined;
  };
};
export { validCyrillicInEmail };